// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ActivitiesPage.css - Based on Figma Design System */

.activities-page {
  width: 100%;
  min-height: 100%;
  background-color: #F4F4F4;
  padding: 40px 0;
}

.activities-loading,
.activities-error {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 18px;
  color: #21262A;
}

.activities-error {
  color: #D32F2F;
}

.activities-content {
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 1540px;
  margin: 0 auto;
  padding: 0 40px;
}

/* Header */
.activities-header {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.activities-title {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 900;
  font-size: 48px;
  line-height: 1.2;
  letter-spacing: -0.005em;
  color: #236CFF;
  margin: 0;
}

.activities-description {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.6;
  color: #21262A;
  margin: 0;
  max-width: 700px;
}

/* Carousel Navigation */
.carousel-nav {
  display: flex;
  gap: 12px;
  margin-top: 8px;
  align-self: flex-end;
}

.carousel-nav-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background-color: #FFFFFF;
  border: 2px solid #D5DEE3;
  border-radius: 50%;
  cursor: pointer;
  color: #21262A;
  transition: all 0.2s ease;
}

.carousel-nav-btn:hover:not(.carousel-nav-btn-disabled) {
  background-color: #236CFF;
  border-color: #236CFF;
  color: #FFFFFF;
}

.carousel-nav-btn:focus {
  outline: 2px solid #236CFF;
  outline-offset: 2px;
}

.carousel-nav-btn-disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Carousel Wrapper */
.activities-carousel-wrapper {
  position: relative;
  width: 100%;
  overflow: visible;
}

.activities-carousel {
  display: flex;
  flex-wrap: nowrap;
  gap: 16px;
  padding: 8px 0;
}


/* Activity Card */
.activity-card {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-width: 0;
  background-color: #FFFFFF;
  border-radius: 16px;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.activity-card:hover {
  transform: translateY(-4px);
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.15);
}

/* Card Image */
.activity-card-image {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #DADADA;
  border-radius: 12px;
  overflow: hidden;
}

/* Category overlay on image */
.activity-category {
  position: absolute;
  top: 16px;
  right: 16px;
  display: inline-flex;
  padding: 4px 8px;
  background-color: #FFFFFF;
  border-radius: 24px;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: #21262A;
}

.activity-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Card Content */
.activity-card-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  flex: 1;
}

.activity-card-title {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 900;
  font-size: 16px;
  line-height: 1.2;
  letter-spacing: -0.1px;
  color: #236CFF;
  margin: 0;
}

.activity-card-description {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  color: #21262A;
  margin: 0;
  flex: 1;
}

/* Card Footer - Duration and Button */
.activity-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: auto;
}

.activity-duration {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1.5px solid #21262A;
  border-radius: 8px;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #21262A;
}

.activity-duration svg {
  color: #21262A;
}

.activity-start-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 20px;
  background-color: #205EA3;
  border: none;
  border-radius: 9999px;
  cursor: pointer;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.5;
  color: #FFFFFF;
  transition: background-color 0.2s ease;
  white-space: nowrap;
}

.activity-start-btn:hover {
  background-color: #001a35;
}

.activity-start-btn:focus {
  outline: 2px solid #1C60EA;
  outline-offset: 2px;
}

/* Completion Card */
.completion-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex: 1 1 0;
  min-width: 0;
  padding: 16px;
  background-color: #FFFFFF;
  border-radius: 16px;
  box-sizing: border-box;
}

.completion-card-title {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 900;
  font-size: 16px;
  line-height: 1.2;
  letter-spacing: -0.1px;
  color: #000000;
  margin: 0 0 12px 0;
}

.completion-card-description {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  color: #21262A;
  margin: 0 0 20px 0;
}

.completion-btn {
  display: flex;
  width: 100px;
  justify-content: center;
  align-items: center;
  padding: 8px 20px;
  background-color: transparent;
  border: 2px solid #00254B;
  border-radius: 9999px;
  cursor: pointer;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.5;
  color: #00254B;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.completion-btn:hover {
  background-color: #00254B;
  color: #FFFFFF;
}

.completion-btn:focus {
  outline: 2px solid #00254B;
  outline-offset: 2px;
}

/* Responsive */

/* At 900px and below, switch to 2-column wrap layout */
@media (max-width: 900px) {
  .activities-carousel {
    flex-wrap: wrap;
    gap: 16px;
  }

  .activity-card,
  .completion-card {
    flex: 1 1 calc(50% - 8px);
    min-width: 260px;
  }
}

@media (max-width: 680px) {
  .activities-content {
    padding: 0 20px;
  }

  .activities-title {
    font-size: 32px;
  }

  .activity-card,
  .completion-card {
    flex: 1 1 100%;
  }
}

@media (max-width: 480px) {
  .activities-title {
    font-size: 28px;
  }

  .activities-description {
    font-size: 14px;
  }

  .activity-card-description,
  .completion-card-description {
    font-size: 13px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/ActivitiesPage.css"],"names":[],"mappings":"AAAA,sDAAsD;;AAEtD;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kFAAkF;EAClF,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,cAAc;AAChB;;;AAGA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,OAAO;AACT;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,OAAO;AACT;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,eAAe;;AAEf,uDAAuD;AACvD;EACE;IACE,eAAe;IACf,SAAS;EACX;;EAEA;;IAEE,yBAAyB;IACzB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/* ActivitiesPage.css - Based on Figma Design System */\n\n.activities-page {\n  width: 100%;\n  min-height: 100%;\n  background-color: #F4F4F4;\n  padding: 40px 0;\n}\n\n.activities-loading,\n.activities-error {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 18px;\n  color: #21262A;\n}\n\n.activities-error {\n  color: #D32F2F;\n}\n\n.activities-content {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  max-width: 1540px;\n  margin: 0 auto;\n  padding: 0 40px;\n}\n\n/* Header */\n.activities-header {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.activities-title {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 900;\n  font-size: 48px;\n  line-height: 1.2;\n  letter-spacing: -0.005em;\n  color: #236CFF;\n  margin: 0;\n}\n\n.activities-description {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 1.6;\n  color: #21262A;\n  margin: 0;\n  max-width: 700px;\n}\n\n/* Carousel Navigation */\n.carousel-nav {\n  display: flex;\n  gap: 12px;\n  margin-top: 8px;\n  align-self: flex-end;\n}\n\n.carousel-nav-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  background-color: #FFFFFF;\n  border: 2px solid #D5DEE3;\n  border-radius: 50%;\n  cursor: pointer;\n  color: #21262A;\n  transition: all 0.2s ease;\n}\n\n.carousel-nav-btn:hover:not(.carousel-nav-btn-disabled) {\n  background-color: #236CFF;\n  border-color: #236CFF;\n  color: #FFFFFF;\n}\n\n.carousel-nav-btn:focus {\n  outline: 2px solid #236CFF;\n  outline-offset: 2px;\n}\n\n.carousel-nav-btn-disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* Carousel Wrapper */\n.activities-carousel-wrapper {\n  position: relative;\n  width: 100%;\n  overflow: visible;\n}\n\n.activities-carousel {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 16px;\n  padding: 8px 0;\n}\n\n\n/* Activity Card */\n.activity-card {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 0;\n  min-width: 0;\n  background-color: #FFFFFF;\n  border-radius: 16px;\n  overflow: hidden;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.activity-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.15);\n}\n\n/* Card Image */\n.activity-card-image {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  background: #DADADA;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n/* Category overlay on image */\n.activity-category {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  display: inline-flex;\n  padding: 4px 8px;\n  background-color: #FFFFFF;\n  border-radius: 24px;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 18px;\n  color: #21262A;\n}\n\n.activity-card-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Card Content */\n.activity-card-content {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n  flex: 1;\n}\n\n.activity-card-title {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 900;\n  font-size: 16px;\n  line-height: 1.2;\n  letter-spacing: -0.1px;\n  color: #236CFF;\n  margin: 0;\n}\n\n.activity-card-description {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #21262A;\n  margin: 0;\n  flex: 1;\n}\n\n/* Card Footer - Duration and Button */\n.activity-card-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: auto;\n}\n\n.activity-duration {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  border: 1.5px solid #21262A;\n  border-radius: 8px;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  color: #21262A;\n}\n\n.activity-duration svg {\n  color: #21262A;\n}\n\n.activity-start-btn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 8px 20px;\n  background-color: #205EA3;\n  border: none;\n  border-radius: 9999px;\n  cursor: pointer;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #FFFFFF;\n  transition: background-color 0.2s ease;\n  white-space: nowrap;\n}\n\n.activity-start-btn:hover {\n  background-color: #001a35;\n}\n\n.activity-start-btn:focus {\n  outline: 2px solid #1C60EA;\n  outline-offset: 2px;\n}\n\n/* Completion Card */\n.completion-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  flex: 1 1 0;\n  min-width: 0;\n  padding: 16px;\n  background-color: #FFFFFF;\n  border-radius: 16px;\n  box-sizing: border-box;\n}\n\n.completion-card-title {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 900;\n  font-size: 16px;\n  line-height: 1.2;\n  letter-spacing: -0.1px;\n  color: #000000;\n  margin: 0 0 12px 0;\n}\n\n.completion-card-description {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #21262A;\n  margin: 0 0 20px 0;\n}\n\n.completion-btn {\n  display: flex;\n  width: 100px;\n  justify-content: center;\n  align-items: center;\n  padding: 8px 20px;\n  background-color: transparent;\n  border: 2px solid #00254B;\n  border-radius: 9999px;\n  cursor: pointer;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #00254B;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.completion-btn:hover {\n  background-color: #00254B;\n  color: #FFFFFF;\n}\n\n.completion-btn:focus {\n  outline: 2px solid #00254B;\n  outline-offset: 2px;\n}\n\n/* Responsive */\n\n/* At 900px and below, switch to 2-column wrap layout */\n@media (max-width: 900px) {\n  .activities-carousel {\n    flex-wrap: wrap;\n    gap: 16px;\n  }\n\n  .activity-card,\n  .completion-card {\n    flex: 1 1 calc(50% - 8px);\n    min-width: 260px;\n  }\n}\n\n@media (max-width: 680px) {\n  .activities-content {\n    padding: 0 20px;\n  }\n\n  .activities-title {\n    font-size: 32px;\n  }\n\n  .activity-card,\n  .completion-card {\n    flex: 1 1 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .activities-title {\n    font-size: 28px;\n  }\n\n  .activities-description {\n    font-size: 14px;\n  }\n\n  .activity-card-description,\n  .completion-card-description {\n    font-size: 13px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
